(function () {
  var ROOT_SELECTOR = '#judgeme_product_reviews';
  var DESKTOP_PAGE_SIZE = 3;
  var stateByRoot = new WeakMap();

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getState(root) {
    var state = stateByRoot.get(root);
    if (!state) {
      state = { page: 0, signature: '' };
      stateByRoot.set(root, state);
    }
    return state;
  }

  function getReviewList(root) {
    return root.querySelector('.jdgm-review-list, .jm-review-list, [class*="review-list"]');
  }

  function getReviewText(review) {
    var body = review.querySelector(
      '.jdgm-review-content__body-content, .jm-review-content__body, .jm-review-content, .jdgm-rev__body'
    );
    return cleanText(body && body.textContent);
  }

  function getCardReviewText(review) {
    var text = getReviewText(review).replace(/\s*More$/i, '');
    if (text.length <= 170) return text;
    return text.slice(0, 167).replace(/\s+\S*$/, '').trim() + '...';
  }

  function cloneStars(review) {
    var stars = review.querySelector('.jm-star-rating, .jdgm-rev__rating');
    if (!stars) return null;
    var copy = stars.cloneNode(true);
    copy.classList.add('koa-review-highlight-card__stars');
    copy.removeAttribute('style');
    return copy;
  }

  function queryText(review, selector) {
    var node = review.querySelector(selector);
    return cleanText(node && node.textContent);
  }

  function makeReviewerMeta(review) {
    var avatarNode = review.querySelector('.jm-reviewer-avatar__initial, .jm-reviewer-avatar, .jdgm-rev__icon');
    var initial = cleanText(avatarNode && avatarNode.textContent).slice(0, 1);
    var name = queryText(review, '.jm-reviewer-info__name, .jdgm-rev__author');
    var reviewerText = cleanText(
      (review.querySelector('.jm-reviewer-info, .jdgm-rev__header') || review).textContent
    );
    var dateMatch = reviewerText.match(/\d{2}\/\d{2}\/\d{4}/);
    var isVerified = !!review.querySelector(
      '.jm-verified-buyer-badge, .jm-verified-badge, .jm-verified-by-shop-badge, .jdgm-rev__buyer-badge'
    );

    var meta = document.createElement('div');
    meta.className = 'koa-review-highlight-card__meta';

    if (initial) {
      var avatar = document.createElement('span');
      avatar.className = 'koa-review-highlight-card__avatar';
      avatar.textContent = initial;
      meta.appendChild(avatar);
    }

    if (name) {
      var nameNode = document.createElement('span');
      nameNode.className = 'koa-review-highlight-card__name';
      nameNode.textContent = name;
      meta.appendChild(nameNode);
    }

    if (dateMatch) {
      var dateNode = document.createElement('span');
      dateNode.className = 'koa-review-highlight-card__date';
      dateNode.textContent = dateMatch[0];
      meta.appendChild(dateNode);
    }

    if (isVerified) {
      var verified = document.createElement('span');
      verified.className = 'koa-review-highlight-card__verified';
      verified.textContent = 'Verified';
      meta.appendChild(verified);
    }

    return meta.childNodes.length ? meta : null;
  }

  function makeCard(review) {
    var reviewText = getCardReviewText(review);
    if (!reviewText) return null;

    var card = document.createElement('article');
    card.className = 'koa-review-highlight-card';
    card.setAttribute('role', 'listitem');

    var stars = cloneStars(review);
    if (stars) card.appendChild(stars);

    var quote = document.createElement('p');
    quote.className = 'koa-review-highlight-card__quote';
    quote.textContent = '"' + reviewText + '"';
    card.appendChild(quote);

    var reviewer = makeReviewerMeta(review);
    if (reviewer) card.appendChild(reviewer);

    return card;
  }

  function getReviews(root) {
    var list = getReviewList(root);
    if (!list) return [];

    return Array.prototype.slice
      .call(list.querySelectorAll(':scope > .jm-review-item, :scope > .jdgm-review, :scope > .jdgm-rev'))
      .filter(function (review) {
        return getReviewText(review);
      });
  }

  function getActiveTabText(root) {
    var tabs = root.querySelector('.jm-review-widget-minimal-header__tabs, .jdgm-tabs');
    if (!tabs) return '';
    var active = tabs.querySelector(
      '[aria-selected="true"], [aria-current="true"], .is-active, .active, .jm-active, .jdgm-tab__active, .jdgm-tab--active'
    );
    if (!active) active = tabs.querySelector('button, a, [role="tab"]');
    return cleanText(active && active.textContent);
  }

  function getTotalFromTabs(root, loadedCount) {
    var label = getActiveTabText(root);
    var match = label.match(/\((\d+)\)/);
    return match ? Number(match[1]) : loadedCount;
  }

  function getSignature(root, reviews) {
    return (
      getActiveTabText(root) +
      '::' +
      reviews
        .map(function (review) {
          var verified = review.querySelector(
            '.jm-verified-buyer-badge, .jm-verified-badge, .jm-verified-by-shop-badge, .jdgm-rev__buyer-badge'
          )
            ? 'verified'
            : 'unverified';
          return (review.getAttribute('review-uuid') || getReviewText(review).slice(0, 90)) + ':' + verified;
        })
        .join('|')
    );
  }

  function ensureSubtitle(header) {
    var titleStack = header.querySelector('.jm-stack.jm-stack--space-200');
    if (!titleStack || titleStack.querySelector('.koa-review-subtitle')) return;

    var subtitle = document.createElement('p');
    subtitle.className = 'koa-review-subtitle';
    subtitle.textContent = 'Real reviews from real customers.';
    titleStack.appendChild(subtitle);
  }

  function ensureCarousel(root, tabs) {
    var existing = Array.prototype.slice.call(root.querySelectorAll('.koa-review-carousel'));
    var carousel = existing.shift();
    existing.forEach(function (duplicate) {
      duplicate.remove();
    });

    if (!carousel) {
      carousel = document.createElement('section');
      carousel.className = 'koa-review-carousel';
      carousel.setAttribute('aria-label', 'Customer review cards');
      carousel.innerHTML =
        '<div class="koa-review-carousel__top">' +
        '<p class="koa-review-carousel__count" aria-live="polite"></p>' +
        '<div class="koa-review-carousel__controls">' +
        '<button class="koa-review-carousel__button" type="button" data-koa-review-prev aria-label="Previous reviews">‹</button>' +
        '<button class="koa-review-carousel__button" type="button" data-koa-review-next aria-label="Next reviews">›</button>' +
        '</div>' +
        '</div>' +
        '<div class="koa-review-highlights" role="list"></div>';

      var prev = carousel.querySelector('[data-koa-review-prev]');
      var next = carousel.querySelector('[data-koa-review-next]');
      prev.addEventListener('click', function () {
        movePage(root, -1);
      });
      next.addEventListener('click', function () {
        movePage(root, 1);
      });

      tabs.parentNode.insertBefore(carousel, tabs);
    }

    return carousel;
  }

  function findJudgeNav(root, direction) {
    var selector = [
      '.jm-pagination a',
      '.jm-pagination button',
      '.jdgm-paginate a',
      '.jdgm-paginate button',
      '[class*="pagination"] a',
      '[class*="pagination"] button',
    ].join(',');
    var candidates = Array.prototype.slice.call(root.querySelectorAll(selector));
    var nextPattern = /(next|older|more|›|»|>)/i;
    var prevPattern = /(prev|previous|newer|‹|«|<)/i;
    var pattern = direction > 0 ? nextPattern : prevPattern;

    return candidates.find(function (candidate) {
      if (candidate.closest('.koa-review-carousel')) return false;
      if (candidate.disabled) return false;
      if (candidate.getAttribute('aria-disabled') === 'true') return false;
      if (/disabled/i.test(candidate.className || '')) return false;

      var label = cleanText(
        [
          candidate.getAttribute('aria-label'),
          candidate.getAttribute('title'),
          candidate.getAttribute('rel'),
          candidate.textContent,
        ].join(' ')
      );

      return pattern.test(label);
    });
  }

  function updateControls(root, carousel, reviews, pageSize) {
    var state = getState(root);
    var maxPage = Math.max(0, Math.ceil(reviews.length / pageSize) - 1);
    var hasPrev = state.page > 0 || !!findJudgeNav(root, -1);
    var hasNext = state.page < maxPage || !!findJudgeNav(root, 1);
    var total = getTotalFromTabs(root, reviews.length);
    var count = carousel.querySelector('.koa-review-carousel__count');
    var prev = carousel.querySelector('[data-koa-review-prev]');
    var next = carousel.querySelector('[data-koa-review-next]');

    carousel.classList.toggle('is-single-page', !hasPrev && !hasNext);

    if (count) {
      count.textContent = total === 1 ? '1 review' : total + ' reviews';
    }

    if (prev) prev.disabled = !hasPrev;
    if (next) next.disabled = !hasNext;
  }

  function renderCarousel(root) {
    var header = root.querySelector('.jm-review-widget-minimal-header');
    var tabs = root.querySelector('.jm-review-widget-minimal-header__tabs, .jdgm-tabs');
    var reviews = getReviews(root);
    if (!header || !tabs || !reviews.length) return false;

    root.classList.add('koa-review-widget', 'koa-review-carousel-enabled');
    ensureSubtitle(header);

    var carousel = ensureCarousel(root, tabs);
    var state = getState(root);
    var signature = getSignature(root, reviews);
    if (state.signature !== signature) {
      state.signature = signature;
      state.page = 0;
    }

    var pageSize = DESKTOP_PAGE_SIZE;
    var maxPage = Math.max(0, Math.ceil(reviews.length / pageSize) - 1);
    state.page = Math.max(0, Math.min(state.page, maxPage));

    var list = carousel.querySelector('.koa-review-highlights');
    var start = state.page * pageSize;
    var pageReviews = reviews.slice(start, start + pageSize);

    list.innerHTML = '';
    pageReviews.forEach(function (review) {
      var card = makeCard(review);
      if (card) list.appendChild(card);
    });

    updateControls(root, carousel, reviews, pageSize);
    carousel.classList.remove('is-loading');
    return true;
  }

  function movePage(root, direction) {
    var state = getState(root);
    var reviews = getReviews(root);
    var pageSize = DESKTOP_PAGE_SIZE;
    var maxPage = Math.max(0, Math.ceil(reviews.length / pageSize) - 1);

    if (direction > 0 && state.page < maxPage) {
      state.page += 1;
      renderCarousel(root);
      return;
    }

    if (direction < 0 && state.page > 0) {
      state.page -= 1;
      renderCarousel(root);
      return;
    }

    var judgeNav = findJudgeNav(root, direction);
    if (!judgeNav) return;

    var carousel = root.querySelector('.koa-review-carousel');
    if (carousel) carousel.classList.add('is-loading');
    state.page = 0;
    judgeNav.click();

    window.setTimeout(function () {
      renderCarousel(root);
    }, 900);
  }

  function enhanceRoot(root) {
    if (!root || root.dataset.koaReviewEnhancerAttached === 'carousel') return;
    root.dataset.koaReviewEnhancerAttached = 'carousel';

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        renderCarousel(root);
      });
    }

    schedule();
    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return !(
          mutation.target &&
          mutation.target.closest &&
          mutation.target.closest('.koa-review-carousel')
        );
      });
      if (shouldRun) schedule();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(enhanceRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('jdgm.doneSetup', init);
  window.addEventListener('load', init, { once: true });
})();